import * as React from "react";
import { _MasterDetailView, } from "../../generic/master-detail-view/MasterDetailView";
import { DetailViewBuildings } from "./DetailViewBuildings";
import { MasterViewBuildings } from "./MasterViewBuildings";
export var MasterDetailBuildings = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewBuildings, detailRenderer: DetailViewBuildings }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/MasterDetailBuildings.tsx
// module id = 2732
// module chunks = 3